import React from "react";

const CardLoader = () => (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <div className="animate-pulse">
        <div className="h-4 w-24 bg-gray-200 rounded mb-4"></div>
        <div className="h-8 w-16 bg-gray-300 rounded"></div>
      </div>
    </div>
);

export default CardLoader;